var VehiclesBookingController = /** @class */ (function () {
    /**
     * 
     * @param $scope
     * @param VehicleBookingService {VehicleBookingService}
     * @param $q
     * @param cacheMemoryService
     * @param $message
     * @constructor
     */
    function VehiclesBookingController($scope, VehicleBookingService, $q, cacheMemoryService, $message) {
        this.$scope = $scope;
        this.vehicleBookingService = VehicleBookingService;
        this.$q = $q;
        this.cacheMemoryService = cacheMemoryService;
        this.$message = $message;
        this.vehicles = [];
        this.dates = [];
        this.months = [];
        this.dates = this.getDates(this.$scope.startDate, this.$scope.endDate);
        this.months = this.getMonths(this.$scope.startDate, this.$scope.endDate);
        this.delegateHandel = _.uniqueId("delegate-handel-");
        this.cacheGetAvailableVehicles = this.cacheMemoryService.get('GetAvailableVehicles');
        this.cacheGetAllBookings = this.cacheMemoryService.get('getAllBookings');
        this.onInit();
        this.bindEvents();
    }
    VehiclesBookingController.prototype.bindEvents = function () {
        var _this = this;
        /**
         * Refresh data
         */
        this.$scope.$on('refreshData', function () {
            var startDate = _this.$scope.startDate, endDate = _this.$scope.endDate;
            _this.getData(startDate, endDate, false).then(function (result) {
                _this.vehicles = _this.getVehicleBookings(result.vehicles, result.vehicleBookings);
                _this.safeApply();
            }, _this.$message.error);
        });
    };
    VehiclesBookingController.prototype.onInit = function () {
        var _this = this;
        var startDate = this.$scope.startDate, endDate = this.$scope.endDate;
        this.getData(startDate, endDate, true).then(function (result) {
            _this.vehicles = _this.getVehicleBookings(result.vehicles, result.vehicleBookings);
            if (_this.$scope.initData) {
                _this.getData(startDate, endDate, false).then(function (result) {
                    _this.vehicles = _this.getVehicleBookings(result.vehicles, result.vehicleBookings);
                }, _this.$message.error).finally(function () {
                    if (_this.$scope.onLoad) {
                        _this.$scope.onLoad({
                            vehicles: _this.vehicles
                        });
                    }
                });
            }
            else {
                if (_this.$scope.onLoad)
                    _this.$scope.onLoad({
                        vehicles: _this.vehicles
                    });
            }
        });
    };
    /**
     * Get vehicles booking in week
     * @param {IAvailableVehicle[]} vehicles
     * @param {IVehicleBooking[]} _bookings
     * @returns {IAvailableVehicle[]}
     */
    VehiclesBookingController.prototype.getVehicleBookings = function (vehicles, _bookings) {
        var _this = this;
        var bookings = this.splitBooking(_bookings);
        _.each(vehicles, function (vehicle) {
            var Availabilities = [];
            vehicle.Availabilities = Availabilities;
            _.each(_this.dates, function (dateObj) {
                var date = dateObj.date.format("YYYY-MM-DD");
                var events = _.where(bookings, {
                    StartDate: date,
                    VehicleId: vehicle.VehicleId
                });
                var dayBooking = {
                    Date: date,
                    Events: events,
                    Addable: true
                };
                _.each(vehicle.Unavailabilities, function (dateUnavailabilitie) {
                    if (moment(dateUnavailabilitie, "YYYY-MM-DD").format("YYYY-MM-DD") === date) {
                        dayBooking.Addable = false;
                    }
                });
                Availabilities.push(dayBooking);
            });
        });
        return vehicles;
    };
    /**
     * Get dates list from range
     * @param {string} startDate
     * @param {string} endDate
     * @returns {any[]}
     */
    VehiclesBookingController.prototype.getDates = function (startDate, endDate) {
        var dates = [], mStartDate = moment(startDate, "YYYY-MM-DD"), mEndDate = moment(endDate, "YYYY-MM-DD"), days = mEndDate.diff(startDate, "days");
        for (var i = 0; i <= days; i++) {
            var nextDate = moment(mStartDate).add(i, "days");
            dates.push({
                dayOfWeek: nextDate.format("dd"),
                day: nextDate.format("D"),
                isToday: this.isToday(nextDate),
                date: nextDate
            });
        }
        return dates;
    };
    /**
     * Get months in date range
     * @param {string} startDate
     * @param {string} endDate
     * @returns {string[]}
     */
    VehiclesBookingController.prototype.getMonths = function (startDate, endDate) {
        var months = [];
        if (moment(startDate).format("MM") === moment(endDate).format("MM")) {
            months.push({
                name: moment(startDate).format("MMMM"),
                width: 100
            });
        }
        else {
            for (var i = 0; i < 7; i++) {
                if (moment(startDate).format("MM") !== moment(startDate).add(i, "days").format("MM")) {
                    months.push({
                        name: moment(startDate).format("MMMM"),
                        width: (i / 7) * 100
                    });
                    months.push({
                        name: moment(endDate).format("MMMM"),
                        width: (1 - (i / 7)) * 100
                    });
                    break;
                }
            }
        }
        return months;
    };
    /**
     * Determine a date is today
     * @param date
     * @returns {boolean}
     */
    VehiclesBookingController.prototype.isToday = function (date) {
        return date.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");
    };
    /**
     * Get vehicles from date range
     * @param {string} startDate
     * @param {string} endDate
     * @returns {angular.IPromise<any>}
     */
    VehiclesBookingController.prototype.getAvailableVehicles = function (startDate, endDate) {
        var _this = this;
        return this.cacheGetAvailableVehicles.getCache(startDate + endDate, function () {
            return _this.vehicleBookingService.getAvailableVehicles(startDate, endDate);
        });
    };
    /**
     * Get all bookings from date range
     * @param {string} startDate
     * @param {string} endDate
     * @returns {any}
     */
    VehiclesBookingController.prototype.getAllBookings = function (startDate, endDate) {
        var _this = this;
        return this.vehicleBookingService.getAllBookings(startDate, endDate).then(function (items) {
            _this.cacheGetAllBookings.set(startDate + endDate, items);
            return items;
        });
    };
    /**
     * Get all data from date range
     * @param {string} startDate
     * @param {string} endDate
     * @param {boolean} cached
     * @returns {angular.IPromise<any>}
     */
    VehiclesBookingController.prototype.getData = function (startDate, endDate, cached) {
        var _this = this;
        return this.$q(function (resolve, reject) {
            if (cached) {
                var vehicles = _this.cacheGetAvailableVehicles.get(startDate + endDate) || [], vehicleBookings = _this.cacheGetAllBookings.get(startDate + endDate) || [];
                resolve({
                    vehicles: vehicles,
                    vehicleBookings: vehicleBookings
                });
            }
            else {
                _this.getAvailableVehicles(startDate, endDate).then(function (vehicles) {
                    _this.getAllBookings(startDate, endDate).then(function (vehicleBookings) {
                        resolve({
                            vehicles: vehicles,
                            vehicleBookings: vehicleBookings
                        });
                    }, reject);
                }, reject);
            }
        });
    };
    /**
     * Split bookings to list of dayBooking
     * @param {IVehicleBooking[]} bookings
     * @returns {IVehicleBooking[]}
     */
    VehiclesBookingController.prototype.splitBooking = function (bookings) {
        var list = [];
        _.each(bookings, function (booking) {
            if (booking.StartDate === booking.EndDate) {
                booking.StartDate = booking.EndDate = moment(booking.StartDate, "YYYY-MM-DD").format("YYYY-MM-DD");
                list.push(booking);
            }
            else {
                var days = moment(booking.EndDate, 'YYYY-MM-DD').diff(moment(booking.StartDate, "YYYY-MM-DD"), "days");
                for (var i = 0; i <= days; i++) {
                    var item = _.clone(booking), date = moment(booking.StartDate, "YYYY-MM-DD").add(i, 'days').format("YYYY-MM-DD");
                    item.StartDate = date;
                    item.EndDate = date;
                    if (i === 0) {
                        item.StartTime = booking.StartTime;
                        item.EndTime = "23:59";
                    }
                    if (i === days) {
                        item.StartTime = "00:00";
                        item.EndTime = booking.EndTime;
                    }
                    if (i !== 0 && i !== days) {
                        item.StartTime = "00:00";
                        item.EndTime = "23:59";
                    }
                    list.push(item);
                }
            }
        });
        return list;
    };
    VehiclesBookingController.prototype.safeApply = function (fn) {
        var phase = this.$scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        }
        else {
            this.$scope.$apply(fn);
        }
    };
    VehiclesBookingController.$inject = ['$scope', 'VehicleBookingService', '$q', 'CacheMemoryService', '$message'];
    return VehiclesBookingController;
}());
angular.module('shared').directive('vehiclesBooking', function () {
    return {
        restrict: 'E',
        controller: VehiclesBookingController,
        controllerAs: 'vm',
        templateUrl: 'js/internal/vehiclebookings/directives/vehicles-booking/vehicles-booking.html',
        scope: {
            startDate: "=",
            endDate: "=",
            initData: "=",
            onLoad: "&"
        }
    };
});
